import * as React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import { YouToube } from './Model';
import ReactPlayer from 'react-player';

export function YouTubeListItem(props: { item: YouToube }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%'  }}>
            <CardContent sx={{ flex: 'auto' }}>
                <ReactPlayer
                    width="100%"
                    height="100%"
                    url={props.item.url} />
            </CardContent>
        </Box>
    );
}
